import React from 'react';
import { shiftSummaryDashboardToAction } from "./FatigueAssessmentPageSelector";
import { FatigueAssessmentView } from './FatigueAssessmentView';
import FatigueAssessmentDashboard from "./FatigueAssessmentDashboard";

const FatigueAssessmentDashboardToAction = () => {
    return (
        <FatigueAssessmentDashboard
            page={shiftSummaryDashboardToAction}
            pageView={FatigueAssessmentView.ToAction}
        />
    );
}

export default FatigueAssessmentDashboardToAction;
